import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Sparkles, Mountain, Infinity as InfinityIcon } from "lucide-react";

const PILLARS = [
  {
    name: "René",
    meaning: "Renacimiento",
    icon: Sparkles,
    text: "El origen, la idea fundacional. Cada estrategia financiera comienza con un nuevo punto de vista sobre el patrimonio.",
  },
  {
    name: "Azpeitia",
    meaning: "Roca, estabilidad",
    icon: Mountain,
    text: "El fundamento sobre el que se construye. Decisiones técnicas, estructuradas y respaldadas por las mejores instituciones del mercado.",
  },
  {
    name: "Smeke",
    meaning: "Legado y continuidad",
    icon: InfinityIcon,
    text: "El horizonte. Lo que se construye trasciende: protege a las generaciones que vienen y honra a las que precedieron.",
  },
];

const StoryPreview = () => {
  return (
    <section className="py-24 lg:py-36 bg-razmek-blue text-white relative overflow-hidden grain">
      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16">
          <div className="lg:col-span-5">
            <div className="eyebrow text-razmek-gold">Nuestra historia</div>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-5 leading-[1.05]">
              El nombre que
              <br />
              <span className="italic">protege</span> un legado.
            </h2>
            <p className="mt-8 font-sans text-base lg:text-lg leading-relaxed text-white/70 max-w-md">
              RAZMEK nace de tres apellidos y de tres ideas. Cada sílaba es una
              forma de entender el patrimonio: como un comienzo, como una roca y
              como una herencia.
            </p>
            <Link
              to="/historia"
              className="inline-flex mt-10 link-underline font-sans tracking-[0.16em] uppercase text-[11px] text-razmek-gold"
            >
              Leer la historia completa
            </Link>
          </div>

          <div className="lg:col-span-7 space-y-px bg-white/10">
            {PILLARS.map((p, i) => {
              const Icon = p.icon;
              return (
                <motion.div
                  key={p.name}
                  initial={{ opacity: 0, x: 20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: i * 0.12 }}
                  className="bg-razmek-blue p-8 lg:p-10 flex gap-8 items-start"
                >
                  <div className="border border-razmek-gold/40 p-4">
                    <Icon size={22} className="text-razmek-gold" strokeWidth={1.4} />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-baseline gap-4 mb-2">
                      <h3 className="font-serif text-3xl">{p.name}</h3>
                      <span className="font-sans text-[11px] tracking-[0.22em] uppercase text-razmek-gold">
                        {p.meaning}
                      </span>
                    </div>
                    <p className="font-sans text-sm lg:text-base leading-relaxed text-white/70 mt-2">
                      {p.text}
                    </p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StoryPreview;
